module.exports = __webpack_public_path__ + "img/HotAirBalloonLogo-400h.1454fc65.webp";